import React,{useEffect, useState} from 'react';
import { Button, TextLink } from '@vds/buttons';
import './FloatingCart.css';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Title, Body, Micro } from '@vds/typography';
import CustomRow from './CustomRow';
import {
	Accordion,
	AccordionItem,
	AccordionHeader,
	AccordionDetail,
	AccordionTitle,
	AccordionSubTitle
} from '@vds/accordions';
import { PricingLockup } from '@vds/type-lockups';
import { MONTH_CHARGES, MONTH_CHARGES_KEYS } from '../../Pages/CustomizeOrder/containers/constants';
import { Loader } from '@vds/loaders';
import * as SiteAnalytics from '../../sitecatalyst';
import { PRINT_CART } from '../../containers/constants';
import FloatingCartPrintPDF from '../FloatingCart/FloatingCartPrintPDF';
import RemoveServiceModals from '../../Pages/CustomizeOrder/TVServiceComponent/RemoveServiceModal';
import Icon from '@vds/icons';

const LockupWrapper = styled.div`
	display: flex;
`;

const StyledButton = styled(Button)`
    display: inline-block;
    margin-right: 15px;
    width: 11rem;
    @media only screen and (max-width: 600px) {
        margin: 5px 20px 5px 0;
        width: 139px;
    }
    span {
        margin: 0;
    }

`;

const BundleFloatingCart = (props) => {
	const getFloatCartResponse = useSelector((state) => state.CustomizeOrder.getFloatCartResponse);
	const isSavedCartOfferApplied = useSelector((state) => state.CustomizeOrder.isSavedCartOfferApplied);
	const toggleSpinnerInFloatingCart = useSelector((state) => state.FloatingCart.toggleSpinnerInFloatingCart);
	const { headerInfo,BlueJeanInfo, dataInfo, phoneInfo, tvInfo, subTotals, otherServices, equipmentAndOnetimeCharges, equipmentAndOnetimeChargesTotal, taxAndOtherCharges, subTotalequipmentAndOnetimeCharges } = getFloatCartResponse?.planDetails;
	const offerPlanName = getFloatCartResponse?.planDetails?.offerInfo && getFloatCartResponse?.planDetails?.offerInfo[0] ? getFloatCartResponse.planDetails?.offerInfo[0]?.planName : ''
	const sixmonthOffer = offerPlanName.split('|')[0];
	const sixmonthOfferEnd = offerPlanName.split('|')[1];
	const offerPlanPrice = getFloatCartResponse?.planDetails?.offerInfo && getFloatCartResponse?.planDetails?.offerInfo[0] ? getFloatCartResponse.planDetails?.offerInfo[0]?.planPrice : ''
	const otheroffer = getFloatCartResponse?.planDetails?.offerInfo && getFloatCartResponse?.planDetails?.offerInfo[0] ? getFloatCartResponse.planDetails?.offerInfo[0]?.otheroffer : ''
	const otherofferPrice = getFloatCartResponse?.planDetails?.offerInfo && getFloatCartResponse?.planDetails?.offerInfo[0] ? getFloatCartResponse.planDetails?.offerInfo[0]?.otherofferPrice : ''
	const [openConfirmModal,SetOpenConfirmModal]=useState(false)
	const [openCart,setOpenCart]=useState(false)
	const selectedTVPlanId=Array.isArray(props?.selectedTVPlanId)?props?.selectedTVPlanId[0]:props?.selectedTVPlanId;
	const selectTVPlanId=selectedTVPlanId?selectedTVPlanId:props?.savedTVPlanProductId;
	const print = () => {
        const content = document.createElement("div");
        const prtContent1 = document.getElementsByClassName("RsCXl");
        const prtContent2 = document.getElementById("print");
        content.innerHTML = (prtContent1 && prtContent1[0] ? prtContent1[0].innerHTML : '') + (prtContent2?.innerHTML ? prtContent2.innerHTML : '');
        const winPrint = window.open('', 'PRINT');
        // winPrint.setTimeout(function () {
            winPrint.document.write(content.innerHTML);
            winPrint.document.close();
            winPrint.focus();
            winPrint.print();
            winPrint.close();
        // }, 1000);
	}
	const RemoveTvSevice=()=>{
		SetOpenConfirmModal(true)
		}	
		const OpenCloseModal=(close)=>{
			SetOpenConfirmModal(close)
			}
	const openCloseCart=(close)=>{
		setOpenCart(close)
	}
	const windowHeight =  window.innerHeight-88
	return (
		<div className={`${openCart ? "hideCart" : ""} floating-cart bundle`} style={{height:windowHeight}}>
			<Loader active={toggleSpinnerInFloatingCart} />
			{openConfirmModal?
			<RemoveServiceModals 
			OldID={selectTVPlanId}
		 resetTVSubHeaderCall={props.resetTVSubHeaderCall}
		 resetTvAddonsSection={props.resetTvAddonsSection} 
		 OpenCloseModal={OpenCloseModal}
		 />:""}	
		 <div>
		 		<div className="cartClose" onClick={() => openCloseCart(true)}><Icon name="close" size="medium" /></div>
				<Title size="large" primitive="h1">
					Cart summary
				</Title>
				<LockupWrapper className="cart-header">
					<PricingLockup price={headerInfo?.Price?.replace('$', "")} labelTop="Month 1 estimate"
						labelBottom="Plus taxes & fees" />
{PRINT_CART === 'true' && (props.history?.location?.pathname == "/checkout"  || props.history?.location?.pathname == "/save-cart") && <Button primary size="small" onClick={() => print()}>Print cart</Button> }
				</LockupWrapper>
			</div>
			<div className="cart-details">
				<Accordion>
					<AccordionItem opened>
						<AccordionHeader>
							<AccordionTitle>
								<div style={{display:'flex',justifyContent:'space-between', marginRight:'-40px'}}>
								<div style={{width:'75%', marginRight:'5%'}}>{headerInfo && headerInfo?.Title ? headerInfo?.Title?.replace(/<\/?[^>]+>/g, '') : ''}</div>
								{headerInfo?.BundlePrice!==null&&headerInfo?.BundlePrice?<div style={{width:'20%'}}>{headerInfo?.BundlePrice}</div>:<></>}
								</div>
							</AccordionTitle>
						</AccordionHeader>
						<AccordionDetail>
							<AccordionSubTitle>
								Estimated monthly charges. 
							</AccordionSubTitle>
							{(!(String(props.servicesInCart).includes('HSI_INTERNET')||String(props.servicesInCart).includes('STANDARD_PHONE')))&&props.cmpCodeQueryParam!==null&&props.cmpCodeQueryParam&&props.selectedTab !== 'phone'&&!props.checkoutPage ?
							<div className='amex_card'>
								<Body size="large" color="#007AB8">Complete your order to receive a one-time $75 statement credit by 
paying with your enrolled eligible Amex Business Card.</Body></div>:<></>}
							<div className="Service">
								{(dataInfo && dataInfo?.planName) ? (
									<div className="Cart-Title">
										<Body size="medium" bold primitive="h2">
											Internet Plan
										</Body>
										<React.Fragment>
											<div className="Cart">
												<div className="Cart-Items">
													<div className="Cart-Label">
														<span>
															<Body size="medium"  primitive="h2">
																{dataInfo.planName}
															</Body>
														</span>
													</div>
													<div className="Cart-data" style={{display:'flex',justifyContent:'flex-end',width:String(dataInfo.planName).includes('upgraded to') ? '255px' : String(dataInfo.planPrice).includes('Included') ? '185px' : 'auto'}}>
														<Body size="medium" primitive="h2">{dataInfo.planPrice}</Body>
													</div>
												</div>
												{props.addressQualificationDetails?.LQPost?.Is_BaltimoreDCzipcode === "Y" && offerPlanName.includes("6 month credit")?
													<div className="Cart-Items">
														<div className="Cart-Label">
															<span  className={"offerText"}>
															<Body size="small" bold primitive="h2">
																{sixmonthOffer ? sixmonthOffer : ''}
															</Body>
															</span>
															<span style={{fontSize:"0.75rem"}}>{sixmonthOfferEnd ? sixmonthOfferEnd : ''}</span>
														</div>
														<div className="Cart-data" style={{display:'flex',justifyContent:'flex-end',width:String(dataInfo.planName).includes('upgraded to') ? '265px' : String(dataInfo.planPrice).includes('Included') ? '185px' : 'auto'}}>
															<Body size="medium" primitive="h2">{offerPlanPrice ? offerPlanPrice : ''}</Body>
														</div>
													</div>
												: 	<span  className={isSavedCartOfferApplied === "Y"? "Saved-Cart-Offer-Text":""}>
													{getFloatCartResponse?.planDetails?.offerInfo?.map((item, i) =>{
														return (<Body size="small" bold primitive="h2">
															{item.planName.includes('Fios & Business Wireless Offer') ? <span style={{color:'#00ac3e'}}>{item.planName}</span> : item.planName}
														</Body>)
													})}
														
													</span>
												}
											</div>
										</React.Fragment>

									</div>
								) : null}

								{phoneInfo ? (
									<div className="Cart-Title">
										<Body size="medium" bold primitive="h2">
											{headerInfo.ServiceType === "BDV" || phoneInfo.planName.includes("Business Digital Voice") ? "Business Digital Voice" : "Standard phone"}
										</Body>
										<div className="Cart">
											{phoneInfo ? (
												<div>
													<div className="Cart-Label">
														<div style={{display:'flex'}}>
														<span style={{width:'40%'}}>
															<Body size="medium" primitive="h2">
																{phoneInfo.noOfLines} Line{phoneInfo.noOfLines > 1 ? 's' : ''}
															</Body>
														</span>
														{/* <div style={{display:'flex',justifyContent:'flex-end',width:'60%'}}>
														<Body size="medium" primitive="h2">
															{phoneInfo.planPrice}
														</Body>
														</div> */}
														</div>
														<span className="Cart-item">
																{phoneInfo.lines?.map((item, i) => {
																	return (
																		<div style={{display:'flex'}}>
																		<div key={i} style={{width:'88%'}}>
																		<Body size="medium" primitive="h2">
																			{' '}
																			{item.TN
																				? item.TN?.replace(
																					/(\d{3})(\d{3})(\d{4})/g,
																					'($1) $2-$3'
																				)
																				: ''} {"- "}{item.planName
																					? item.planName
																					: ''}
																		</Body>
																		</div>
																		<div style={{display:'flex',width:String(item?.total).includes('Included') ? '255px' : 'auto',justifyContent:'flex-end'}}>
																		<Body size="medium" primitive="h2">
																			{item?.total}
																		</Body>
																		</div>
																		</div>
																	);

																})}
														</span>
													</div>
												</div>
											) : null}
											{phoneInfo.FaxLine?.length > 0 ? (
												<div className="Cart-Items">
													<div className="Cart-Label">
														<span>
															<Body size="medium" primitive="h2">
																{phoneInfo.FaxLine?.length} Standard line{phoneInfo.FaxLine?.length > 1 ? 's' : ''}
															</Body>
														</span>
														<span className="Cart-item">
															<Body size="medium" primitive="h2">
																{phoneInfo.FaxLine.map((item, i) => {
																	return (
																		<div key={i}>
																			{' '}
																			{item.keyWord
																				? item.keyWord?.replace(
																					/(\d{3})(\d{3})(\d{4})/g,
																					'($1) $2-$3'
																				)
																				: ''}
																		</div>
																	);
																})}
															</Body>
														</span>
													</div>
													<div className="Cart-data">
														<Body size="medium" primitive="h2">
															{phoneInfo.FaxLine[0].Price}
														</Body>
													</div>
												</div>
											) : null}

											{phoneInfo.phoneServices?.length ?

												phoneInfo.phoneServices.map((item, i) => {
													return (
														<div className="Cart-Items">
															<div className="Cart-Label">
																<span>
																	<Body size="medium" primitive="h2">
																		<div key={i}>{item.Name}</div>
																	</Body>
																</span>
															</div>
															<div className="Cart-data">
																<Body size="medium" primitive="h2">
																	<div key={i}>{item.Rc == 0 ? 'Included' : item.Rc}</div>
																</Body>
															</div>
														</div>)
												})

												: null}
										</div>
									</div>
								) : null}
						{tvInfo && (
							<div className="Cart-Title">
							<Body size="medium" bold primitive="h2">
							TV Plan &nbsp;&nbsp;
							<span>
							<TextLink
							type="standAlone"
							inverted={false}
						    onClick={() => RemoveTvSevice()}
							disabled=											
							{props?.history?.location?.pathname === "/save-cart" || 
							 props?.history?.location?.pathname === "/checkout"?true:false}
							size="small"
							primitive="h3"
							className="removeTVText"
							>Remove</TextLink>
							</span>
							</Body>
							</div>
						)}
								<div className="Cart">
									{tvInfo ? (
										<div className="Cart-Items">
											<div className="Cart-Label">
												<span>
													<Body size="medium" primitive="h2">
														{tvInfo.planName}
													</Body>
												</span>
											</div>
											<div className="Cart-data">
												<Body size="medium" primitive="h2">{tvInfo.planPrice || "Included"}</Body>
											</div>
										</div>
									) : null}

									<div className="Cart-Items">
										<div className="Cart-Label">
											<span>
												<Body size="medium" bold primitive="h2">
													{subTotals.services?.Name}
												</Body>
											</span>
											<span>
												<Micro viewport="desktop" primitive="h2">
													Estimated monthly charges
												</Micro>
											</span>
										</div>
										<div className="Cart-data">
											<Body size="medium" bold primitive="h2">
												{subTotals.services.price}
											</Body>
										</div>
									</div>

									{(dataInfo || tvInfo) && (otherServices?.length > 0 || tvInfo?.tvServices?.length > 0 || tvInfo?.MovieChannelsPack?.length > 0) ? (
										<div>
	                                        <Body size="medium" bold primitive="h2">
												{/* Internet Service */}
												Other Service
											</Body>

											<div className="Cart-Items">
												<div className="Cart-Label">
													<span>
														<Body size="medium" primitive="h2">
															{otherServices.map((item, i) => {
																return item.ProdOfferDesc ? 
																<div key={i}><div>{item.Product}</div>
																<Micro viewport="desktop" primitive="h6">
																	{item.ProdOfferDesc}</Micro>
																	</div> : <div key={i}>{item.Product}</div>;
															})}
															{tvInfo && tvInfo.tvServices.map((item, i) => {
																return <div key={i}>{item.prdName}</div>;
															})}
															{tvInfo && tvInfo.MovieChannelsPack?.length > 0 && <>
																<div>Movie Channels Pack</div>
																{tvInfo.MovieChannelsPack.map((item, i) => {
																	return item.channelName.toLowerCase()!== 'max' ? <div key={i}>&nbsp;-&nbsp;{item.channelName +'\u00AE'}</div>:<div key={i}>&nbsp;-&nbsp;{item.channelName}</div>
																})}
															</>}
														</Body>
													</span>
												
												</div>
												<div className="Cart-data month-details">
													<Body size="medium" primitive="h2">
														{otherServices.map((item, i) => {
															return item.ProdOfferDesc ?[<div key={i}>{item.price}</div>,<div>&nbsp;</div>]:<div key={i}>{item.price}</div>;
														})}
														{tvInfo && tvInfo.tvServices.map((item, i) => {
															return <div className="align-right" key={i}>{item.Price}</div>;
														})}
														{tvInfo && tvInfo.MovieChannelsPack?.length > 0 && <>
															<div className="align-right">{tvInfo.MoviechannelsPackPrice}</div>
															{tvInfo.MovieChannelsPack.map((item, i) => {
																return <div key={i}>Included</div>
															})}
														</>}
													</Body>
												</div>
										
											</div>
										
											<div className="Cart-Items">
												<div className="Cart-Label">
													<span>
														<Body size="medium" bold primitive="h2">
															{/* Sub total Internet service */}
															{subTotals.otherServices.Name}
														</Body>
													</span>
													<span>
														<Micro viewport="desktop" primitive="h2">
															Estimated monthly charges
														</Micro>
													</span>
												</div>
												<div className="Cart-data month-details">
													<Body size="medium" bold primitive="h2">
														{subTotals.otherServices.price}
													</Body>
												</div>
											</div>
										</div>
									) : null}
									{subTotals.Totalmonthlycharges!==null&&subTotals.Totalmonthlycharges&&
									subTotals.Totalmonthlychargesprice!==null&&subTotals.Totalmonthlychargesprice?
									<div className="Cart-Items">
										<div className="Cart-Label">
											<span>
												<Body size="medium" bold primitive="h2">
													{/* Sub total Internet service */}
													{subTotals.Totalmonthlycharges}
												</Body>
											</span>
										</div>
										<div className="Cart-data month-details">
											<Body size="medium" bold primitive="h2">
												{subTotals.Totalmonthlychargesprice}
											</Body>
										</div>
									</div>:<></>}
									{props.addressQualificationDetails?.LQPost?.Is_BaltimoreDCzipcode === "Y"?
										<div className="Cart-Items">
											<div className="Cart-Label">
												<Body size="medium" primitive="h2">
													{otheroffer ? otheroffer : ''}
												</Body>
											</div>
											<div className="Cart-data" style={{display:'flex',justifyContent:'flex-end',width:String(dataInfo.planName).includes('upgraded to') ? '265px' : String(dataInfo.planPrice).includes('Included') ? '185px' : 'auto'}}>
												<Body size="medium" primitive="h2">{otherofferPrice ? otherofferPrice : ''}</Body>
											</div>
										</div>
									:null}
									{/* {tvInfo?.tvServices?.length > 0 ? (
										<div>
											<Body size="medium" bold primitive="h2">
												TV Service
											</Body>

											<div className="Cart-Items">
												<div className="Cart-Label">
													<span>
														<Body size="medium" primitive="h2">
															{tvInfo.tvServices.map((item, i) => {
																return <div key={i}>{item.prdName}</div>;
															})}


															{tvInfo.MovieChannelsPack?.length > 0 && <>
																<div>Movie Channels Pack</div>
																{tvInfo.MovieChannelsPack.map((item, i) => {
																	return <div key={i}>&nbsp;-&nbsp;{item.channelName}</div>
																})}
															</>}

														</Body>
													</span>
												</div>
												<div className="Cart-data month-details">
													<Body size="medium" primitive="h2">
														{tvInfo.tvServices.map((item, i) => {
															return <div className="align-right" key={i}>{item.Price}</div>;
														})}
														{tvInfo.MovieChannelsPack?.length > 0 && <>
															<div className="align-right">{tvInfo.MoviechannelsPackPrice}</div>
															{tvInfo.MovieChannelsPack.map((item, i) => {
																return <div key={i}>Included</div>
															})}
														</>}

													</Body>
												</div>
											</div>

											<div className="Cart-Items">
												<div className="Cart-Label">
													<span>
														<Body size="medium" bold primitive="h2">
															Subtotal TV service
														</Body>
													</span>
													<span>
														<Micro viewport="desktop" primitive="h2">
															Estimated monthly charges
														</Micro>
													</span>
												</div>
												<div className="Cart-data month-details">
													<Body size="medium" bold primitive="h2">
														{tvInfo.SubtotalTVservice.price}
													</Body>
												</div>
											</div>
										</div>
									) : null} */}
								</div>
							</div>
						</AccordionDetail>
					</AccordionItem>
					<AccordionItem opened>
						<AccordionHeader>
							<AccordionTitle>Equipment and one-time charges</AccordionTitle>
						</AccordionHeader>
						<AccordionDetail>
							<AccordionSubTitle>
								Equipment, activation and other fees can be billed over installments. You can make installment updates during checkout.
							</AccordionSubTitle>
							<div className="Service">
								<div className="Cart-Title">
									<Body size="medium" bold primitive="h2">
									</Body>
								</div>
								<div className="Cart">
									<div>
										{equipmentAndOnetimeCharges?.map((item, i) => {
											const offerName = item.offerName;
											const offerNameWithDetails = item.installmentOption;
											return (
												<CustomRow
													key={i}
													offerName={offerName}
													price={item.price}
													installmentOption={item.installmentOption}
													offerString={"Fee Waived"}
												/>
											);
										})}
									</div>
									<div className="Cart-Items">
										<div className="Cart-Label">
											<span>
												<Body size="medium" bold primitive="h2">
													Subtotal equipment and one-time charges
												</Body>
												<Micro viewport="desktop" primitive="h2">
													Estimated monthly charge by installments
												</Micro>
											</span>
										</div>
										<div className="Cart-data month-details">
											<Body size="medium" bold primitive="h2">
												{equipmentAndOnetimeChargesTotal?.subTotalequipmentAndOnetimeCharges.price}
											</Body>
										</div>
									</div>
								</div>
							</div>
						</AccordionDetail>
					</AccordionItem>
					<AccordionItem opened>
						<AccordionHeader>
							<AccordionTitle>Taxes and other charges</AccordionTitle>
						</AccordionHeader>
						<AccordionDetail>
							<AccordionSubTitle>Estimated taxes and other Verizon charges.</AccordionSubTitle>
							<div className="Service">
								<div className="Cart">
									<div>
										
										{taxAndOtherCharges?.taxAndotherCharges?.map((item, i) => {
											// "3 Line IP Phone(1) = $85, Installment 1 of 12"

											const offerName = item.offerName;
											const offerNameWithDetails = "";

											return (
												<CustomRow
													key={i}
													offerName={offerName}
													price={item.price}
													installmentOption={item.installmentOption}
													offerNameWithDetails={offerNameWithDetails}
													offerString={"Fee Waived"}
												/>
											);
										})}

									</div>
									{taxAndOtherCharges?.Tax?.price !== "$0.00"  && <div className="Cart-Items">
										<div className="Cart-Label">
											<span>
												<Body size="medium" primitive="h2">{taxAndOtherCharges?.Tax?.Name}</Body>
											</span>
										</div>
										<div className="Cart-data month-details">
											<span>
												<Body size="medium" primitive="h2">{taxAndOtherCharges?.Tax?.price }</Body>
											</span>
										</div>
									</div>
									}
									{taxAndOtherCharges?.subTotalTaxCharges?.services?.price !== "$0.00" && <div className="Cart-Items">
										<div className="Cart-Label">
											<span>

												<Body size="medium" bold primitive="h2">
													{taxAndOtherCharges?.subTotalTaxCharges?.services?.Name}
												</Body>
											</span>
										</div>
										<div className="Cart-data month-details">
											<Body size="medium" bold primitive="h2">
												{taxAndOtherCharges?.subTotalTaxCharges?.services?.price}
											</Body>
										</div>
									</div>
									}	
								</div>

							</div>
						</AccordionDetail>
					</AccordionItem>

				</Accordion>
			</div>
			<div className="hide-pdf-content">
				<FloatingCartPrintPDF />
			</div>
		</div>
	);
};

export default BundleFloatingCart;
